<template>
  <div class="flex items-end justify-between px-6 py-5 bg-white/30 dark:bg-gray-900 backdrop-blur space-x-4">
    <div class="flex-grow">
      <div v-if="smsFromNumber && channel.sms" class="border text-orange-600 dark:text-orange-500 border-orange-200 dark:border-orange-800 rounded-xl bg-orange-100/50 dark:bg-orange-500/10 relative px-3 py-2 mb-2 flex items-center">
        <OIcon icon="warningBold" class="mr-2" />
        <div>
          <p class="text-sm opacity-70 font-semibold">
            You are using your own number for SMS
          </p>

          <p class="text-sm opacity-70">
            SMS replies will be sent to your own number and not appear in this chat
          </p>
        </div>
      </div>
      <div class="flex-grow border border-gray-300 rounded-xl bg-gray-100 dark:bg-gray-900 dark:border-gray-800 relative px-2">
        <template v-if="attachments.length">
          <AttachmentsPreviewList :attachments="attachments" @remove="" />
        </template>

        <div class="min-h-10 flex items-center justify-between">
          <ContentEditableField
            v-model="body"
            :disabled="loading"
            class="w-full px-1 py-2 text-base border-0 resize-none bg-transparent"
            @keydown="handleComposerKeydown"
          />

          <div class="flex items-center space-x-2 p-1">
            <Attach
              v-if="customer"
              v-model="attachments"
              :customer="customer"
              v-model:uploads="uploads"
            />

            <Emoji
              v-model="body"
            />

            <div class="hidden px-1">
              <div class="border-l h-6 flex-shrink-0 block" />
            </div>

            <!--<OTooltip v-if=:text="$t('components.message.elements.Send.sendAsEmail')" placement="top">
              <label
                for="channel-email"
                :class="[
                  'relative h-8 w-8 flex items-center justify-center rounded-xl',
                  channel.email ? 'bg-primary-600 text-white dark:bg-primary-500/20 dark:text-primary-500' : 'text-gray-600 hover:bg-gray-200 hover:dark:bg-gray-800 dark:text-gray-400',
                ]"
              >
                <input id="channel-email" v-model="channel.email" class="appearance-none" type="checkbox">

                <OIcon icon="email" />
              </label>
            </OTooltip>

            <OTooltip :text="$t('components.message.elements.Send.sendAsSMS')" placement="top">
              <label
                for="channel-sms"
                :class="[
                  'relative h-8 w-8 flex items-center justify-center rounded-xl cursor-pointer',
                  channel.sms ? 'bg-primary-600 text-white dark:bg-primary-500/20 dark:text-primary-500' : 'text-gray-600 hover:bg-gray-200 hover:dark:bg-gray-800 dark:text-gray-400',
                ]"
              >
                <input id="channel-sms" v-model="channel.sms" class="appearance-none" type="checkbox">

                <OIcon icon="mobile" />
              </label>
            </OTooltip>-->
          </div>
        </div>

        <div class="border-t py-1 px-1 flex items-center justify-between">
          <o-dropdown
            placement="top-start"
          >
            <a class="text-primary-600 text-sm cursor-pointer">
              {{ sendAsLabel }}
            </a>

            <template #content>
              <div>
                <div
                  class="flex items-center pb-2 pt-1 px-3 border-b dark:border-gray-800"
                  :class="deliveryChannelClass(allowEmail)"
                  @click="toggleDeliveryChannel('email')"
                >
                  <toggle-field v-model="channel.email" :disabled="!allowEmail" size="xs" class="mr-3" @click.stop />
                  <div>
                    <label class="text-sm opacity-80 leading-none">{{ $t('components.message.elements.Send.sendAsEmail') }}</label>
                    <p class="text-sm opacity-70 leading-none">
                      {{ customer?.email ? $t('components.message.elements.Send.sendingTo', { contact: customer.email }) : $t('components.message.elements.Send.noEmail') }}
                    </p>
                  </div>
                </div>

                <div
                  class="flex items-center py-2 px-3 border-b dark:border-gray-800"
                  :class="deliveryChannelClass(allowSms)"
                  @click="toggleDeliveryChannel('sms')"
                >
                  <toggle-field v-model="channel.sms" :disabled="!allowSms" size="xs" class="mr-3" @click.stop />
                  <div>
                    <label class="text-sm opacity-80 leading-none">{{ $t('components.message.elements.Send.sendAsSMS') }}</label>
                    <p class="text-sm opacity-70 leading-none">
                      {{ customer?.phone ? $t('components.message.elements.Send.sendingTo', { contact: customer.phone }) : $t('components.message.elements.Send.noPhone') }}
                    </p>
                  </div>
                </div>

                <div class="flex items-center py-2 px-3">
                  <toggle-field v-model="channel.app" :disabled="true" size="xs" class="mr-3" />
                  <div>
                    <label class="text-sm opacity-80 leading-none">{{ $t('components.message.elements.Send.sendAsApp') }}</label>
                    <p class="text-sm opacity-70 leading-none">
                      {{ allowApp ? $t('components.message.elements.Send.hasApp') : $t('components.message.elements.Send.noApp') }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </o-dropdown>

          <Counter v-if="channel.sms" v-model="body" />
        </div>
      </div>
    </div>

    <div class="h-8 border-r mb-1" />

    <div class="flex-shrink-0 ml-4">
      <OTooltip :text="$t('components.message.elements.Send.shiftEnterToSend')" placement="top">
        <OButton
          icon="send"
          variant="primary"
          size="lg"
          rounded="rounded-xl"
          :loading="loading"
          :disabled="!canSend"
          @click="sendMessage"
        >
          <span>{{ $t('general.send') }}</span>
          <span class="ml-2 hidden items-center gap-0.5 text-[10px] leading-none opacity-80 sm:inline-flex">
            <kbd class="rounded border border-white/30 bg-white/15 px-1 py-0.5 font-sans font-medium">Shift</kbd>
            <span>+</span>
            <kbd class="rounded border border-white/30 bg-white/15 px-1 py-0.5 font-sans font-medium">Enter</kbd>
          </span>
        </OButton>
      </OTooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import Attach from './send/Attach.vue'
import Emoji from './send/Emoji.vue'
import Counter from './send/Counter.vue'

import AttachmentsPreviewList from './attachments/preview/List.vue'
import { CustomerMessageSender } from '~/_api/models/customerMessage'

import { ContentEditableField, ToggleField } from '@/components/fields'

const { $api, $notification, $i18n, $auth } = useNuxtApp()

interface Props {
  customer?: Record<string, any> | null
}

const props = withDefaults(defineProps<Props>(), {
  customer: null,
})

const emit = defineEmits<{
  (e: 'success', message: any): void
}>()

const body = ref('')
const attachments = ref<any[]>([])
const uploads = ref<Record<string, File>>({})
const channel = ref({
  email: true,
  sms: false,
  app: true,
})
const loading = ref(false)

const canSend = computed(() => {
  return !loading.value
    && (!!body.value.trim() || !!attachments.value.length)
    && (channel.value.email || channel.value.sms || channel.value.app)
})

const smsFromNumber = computed(() => {
  return ($auth as any).info?.location?.smsFromNumber
})

const allowEmail = computed(() => {
  return Boolean(props.customer?.messageChannels?.email?.available)
})

const allowSms = computed(() => {
  return Boolean(props.customer?.messageChannels?.sms?.available)
})

const allowApp = computed(() => {
  return Boolean(props.customer?.messageChannels?.app?.available)
})

type SelectableDeliveryChannel = 'email' | 'sms'

const deliveryChannelClass = (available: boolean) => {
  return available ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50' : 'cursor-not-allowed opacity-60'
}

const toggleDeliveryChannel = (key: SelectableDeliveryChannel) => {
  if (key === 'email' && !allowEmail.value) {
    return
  }

  if (key === 'sms' && !allowSms.value) {
    return
  }

  channel.value[key] = !channel.value[key]
}

const handleComposerKeydown = (event: KeyboardEvent) => {
  if (event.key !== 'Enter' || !event.shiftKey || event.isComposing) {
    return
  }

  event.preventDefault()
  sendMessage()
}

const sendAsLabel = computed(() => {
  if (channel.value.email && channel.value.sms && channel.value.app) {
    return $i18n.t('components.message.elements.Send.sendAsEmailAndSMSAndApp')
  }

  if (channel.value.email && channel.value.sms) {
    return $i18n.t('components.message.elements.Send.sendAsEmailAndSMS')
  }

  if (channel.value.email && channel.value.app) {
    return $i18n.t('components.message.elements.Send.sendAsEmailAndApp')
  }

  if (channel.value.sms && channel.value.app) {
    return $i18n.t('components.message.elements.Send.sendAsSMSAndApp')
  }

  if (channel.value.email) {
    return $i18n.t('components.message.elements.Send.sendAsEmail')
  }

  if (channel.value.sms) {
    return $i18n.t('components.message.elements.Send.sendAsSMS')
  }

  if (channel.value.app) {
    return $i18n.t('components.message.elements.Send.sendAsApp')
  }

  return $i18n.t('components.message.elements.Send.noDeliveryChannelSelected')
})

watch(() => props.customer, () => {
  if (props.customer?.messageChannels?.app?.available) {
    channel.value.app = true
  } else {
    channel.value.app = false
  }

  if (props.customer?.messageChannels?.email?.available) {
    channel.value.email = true
    channel.value.sms = false
    return
  }

  if (!props.customer?.messageChannels?.email?.available && props.customer?.messageChannels?.sms?.available) {
    channel.value.sms = true
    channel.value.email = false
    return
  }

  channel.value.email = false
  channel.value.sms = false
}, { immediate: true })

const sendMessage = async () => {
  if (!canSend.value) {
    return
  }

  loading.value = true

  try {
    const response = await $api.customerMessage.send({
      customerId: props.customer?.idCustomer,
      subject: '',
      body: body.value,
      attachments: attachments.value,
      sender: CustomerMessageSender.location,
      emailSend: channel.value.email,
      smsSend: channel.value.sms,
    }, uploads.value)

    if (response.data) {
      emit('success', response.data)
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }

  body.value = ''
  attachments.value = []
  uploads.value = {}
  loading.value = false
}
</script>
